export default "__VITE_ASSET__098aad13__"